import { Brick, BrickContext, Role, registerBrick, ErrorFlow } from 'olympe';
import { updateAndritzUser } from './function/andritzUserCtr';

export default class UpdateAndritzUser extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {AndritzUser} andritzUser
     * @param {string} password
     * @param {string} confirmPassword
     * @param {Role} newRole
     * @param {string} newFullName
     * @param {number} passwordMinLength
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     */
    async update(
        $,
        [andritzUser, password, confirmPassword, newRole, newFullName, passwordMinLength],
        [forwardEvent, setErrorFlow]
    ) {
        // Ensure values are valid
        // -- Password
        if (password) {
            if (password.length < passwordMinLength) {
                setErrorFlow(
                    ErrorFlow.create(
                        `Password mus have at least ${passwordMinLength} characters.`,
                        0
                    )
                );
                return;
            } else if (password !== confirmPassword) {
                setErrorFlow(ErrorFlow.create(`Please make sure your passwords match.`, 0));
                return;
            }
        }

        // -- FullName : add default value if empty
        newFullName = newFullName && newFullName.length > 0 ? newFullName : 'Unknown';

        if (!newRole) {
            setErrorFlow(ErrorFlow.create(`No role specified.`, 0));
            return;
        }

        updateAndritzUser($, andritzUser, password, newRole, newFullName)
            .then(() => {
                forwardEvent();
            })
            .catch((error) => {
                setErrorFlow(ErrorFlow.create(error, 1));
            });
    }
}

registerBrick('018a6409e847297f63c3', UpdateAndritzUser);
